








































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class UploadResult extends Vue {
  @Prop() private readonly data;
}
